import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import { createRef } from 'react';
import debug from '../../debug';
import ValueStore from './ValueStore';

export default class RawValueStore extends ValueStore {
    static _PropType = {
        ...ValueStore._PropType,
        key: PropTypes.number,
    };

    static PropTypes = PropTypes.shape(RawValueStore._PropType);
    init(defaultValue, data) {
        this.defaultValue = defaultValue;
        this.originalValue = defaultValue;
        this.currentValue = defaultValue;

        this.ref = createRef();

        extendObservable(this, /** @class RawValueStore */{
            key: 0,
            changed: false,
            valid: true,
            errorMessage: '',
        }, data);
    }

    _setValue = this.setValue;

    setValue = action((...args) => {
        this._setValue(...args);
        this.key += 1;
        try {
            this.changed = JSON.stringify(this.originalValue) !== JSON.stringify(this.currentValue);
        } catch (error) {
            debug.warn('RawValueStore.setValue failed to JSON.stringify', error);
        }
    });

    focus = () => this.ref?.current?.focus();
}
